module.exports = __webpack_public_path__ + "static/media/marker-ahn.38b654cc.png";